//@author: mandy

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { OrganizationSettingsComponent } from "./organization.settings.component";
import { SearchOptionsModule } from "../search-options/search.options.module";

@NgModule({
    declarations: [OrganizationSettingsComponent],
    imports: [CommonModule, FormsModule, SearchOptionsModule],
    providers: [OrganizationSettingsComponent],
})
export class OrganizationSettingsModule {
    constructor() {}
}
